import React, { Component } from 'react';

import './style.css';
class PolicyPage extends Component {
  render() {
    return (
      <div>

        <center>
			<div id="header0">PRIVACY POLICY</div>
			<div id="content0">Last modified on Oct 12, 2019</div>
		</center>
		<br/>
		
		<div id="content2">
		We do not collect any your data. All permissons which we request only purpose for application's functions. 
		Also, AppLock does not request Internet permisson, so it can not send any data to server.
		</div>
        
		<div id="header2">PACKAGE USAGE STATS</div>
        <div id="content2">
		We need the permission to know that what app is running on top, so we can lock that app.
		</div>
		
		<div id="header2">WRITE SETTINGS</div>
        <div id="content2">
		The write settings permission helps we can lock app rotations as your expectation.	
		</div>
		
		<div id="header2">USE FINGERPRINT</div>
        <div id="content2">
		The permisiona allow you can unlock app easily.	
		</div>
		
		<div id="header2">INTERNET</div>
        <div id="content2">
		It allows application get new configurations.
		</div>
		
		<div id="header2">android.permission.BIND_DEVICE_ADMIN</div>
        <div id="content2">
		Required to prevent someone uninstall AppLock, then it help to protect your device. AppLock uses DEVICE MANAGER permission. It allow application to protect your device.
		</div>
		
		<div id="header2">Changes</div>
        <div id="content2">
		We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.	
		</div>
		
		<div id="header2">Contact Us</div>
        <div id="content2">
		If you have any questions, or to report any violations of the Policy, please contact us at reping.dev@gmail.com.
		</div>
      </div>
    );
  }
}

export default PolicyPage;



// WEBPACK FOOTER //
// ./src/Privacy Policy/AppLock/index.js